import { postAsyncMessage, isIOSBridge } from 'appBridge/bridge'

export const openLink = (link) => isIOSBridge()
  ? postAsyncMessage(`open_payments_view_${window.btoa(link)}`)
  : window.open(link, '_blank')
